import React from 'react';
import { useChatWidgetContext } from '../../ChatWidgetContext';
import { setTransferState } from '../../chatTransferStore';
import { detachRelayListener } from '../../streamRelay';
import styles from '../ChatWidget.module.scss';

interface ExpandChatButtonProps {
  onExpand: (conversationId: number | null) => void;
}

export default function ExpandChatButton(props: ExpandChatButtonProps) {
  const {
    currentConversationId,
    messages,
    streamingText,
    isStreaming,
    selectedContext,
  } = useChatWidgetContext();

  const waitingForConversation = isStreaming && !currentConversationId;

  const handleExpand = () => {
    if (currentConversationId) {
      detachRelayListener();
      setTransferState({
        conversationId: currentConversationId,
        messages,
        streamingText,
        isStreaming,
        selectedContext,
      });
    }
    props.onExpand(currentConversationId);
  };

  return (
    <button
      type="button"
      className={styles.headerButton}
      onClick={handleExpand}
      disabled={waitingForConversation}
      aria-label="Open full chat"
      data-testid="chat-expand-button"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 3H21V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 21H3V15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M21 3L14 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3 21L10 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}
